import React from 'react';
import CardHeader from '@material-ui/core/CardHeader';
import IconButton from '@material-ui/core/IconButton';
import People from '@material-ui/icons/People';
import CardContent from '@material-ui/core/CardContent/CardContent';
import Table from '../General/table';
import { AddListContentButton } from '../General/addListContentButton';
import Card from '@material-ui/core/Card/Card';

const PdfsScreen = (props) => {
  return (
    <Card>
      <CardHeader
        avatar={<IconButton>
          <People />
        </IconButton>}
        title="Pdfs list"
      />
      <CardContent>
        <Table
          handleRowSelect={props.handleRowSelect}
          label="Pdfs"
          rows={props.listRows}
          columns={props.listColumns}
          fixedHeader={true}
          selectable={false}
          multiSelectable={false}
          displaySelectAll={false}
          showCheckboxes={false}
          showRowHover={true}
          page={props.page}
          rowsPerPage={props.rowsPerPage}
          handleRowsPerPage={props.handleRowsPerPage}
          handlePageChange={props.handlePageChange}
          totalRows={props.total}
          clickableRows={true}
          isSortable={true}
          orderBy={props.orderBy}
          order={props.order}
          onRequestSort={props.onRequestSort}
        />
      </CardContent>
      <AddListContentButton onClick={() =>props.history.push('/pdfsAdd')}/>
    </Card>
  );
};

export default PdfsScreen;



// WEBPACK FOOTER //
// ./src/components/Pdfs/PdfsScreen.js